import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";
import notification from "./notification";
const vuexLocal = new VuexPersistence({
  // storage: window.localStorage,
  // reducer: (state) => ({
  //   token: state.token,
  //   // solo este módulo se guardará
  // }),
});
export default createStore({
  state: {
    loggedIn: false,
    token: localStorage.getItem("token"),
    user: null,
    representative: null,
    CidiCookie: null,
    width: 0,
    categorias: {},
    tramiteStore: "",
    subcategoryState: null,
    procedureSelected: null,
    categoryStore: null,
    changeStateStore: null,
    modalUnreadSeen: false,
    categoriesRelations: null,
    isSidebarOpen: true,
    loadingGlobal: false,
    sectorLevel: "subcategories",
    currentSubCategoryId: null,
    currentSectorId: null,

    filters: {
      tramites: {},
      turnos: {},
      tareas: {},
      vecinos: {},
    },
  },
  getters: {},
  mutations: {
    loggedIn(state, asd) {
      state.user = asd;
    },
    loggedInRepresentative(state, asd) {
      state.representative = asd;
    },
    setCidi(state, asd) {
      state.CidiCookie = asd;
    },
    login(state) {
      state.loggedIn = true;
    },
    outLogin(state) {
      state.loggedIn = false;
      state.user = null;
      state.representative = null;
      state.tramiteStore = null;
      state.subcategoryState = null;
      state.categoryStore = null;
      state.CidiCookie = null;
      state.categoriesRelations = null;
      state.filters = {
        tramites: {},
        turnos: {},
        tareas: {},
        vecinos: {},
      };
    },
    setWidth(state, asd) {
      state.width = asd;
    },
    getCategorias(state, obj) {
      state.categorias = obj;
    },
    setTramite(state, asd) {
      state.tramiteStore = asd;
    },
    setSubCategory(state, asd) {
      state.subcategoryState = asd;
    },
    setCategory(state, asd) {
      state.categoryStore = asd;
    },
    setSectorLevel(state, level) {
      state.sectorLevel = level;
    },
    setCurrentSubCategory(state, id) {
      state.currentSubCategoryId = id;
    },
    setCurrentSectorId(state, id) {
      state.currentSectorId = id;
    },
    clearSectorNavigation(state) {
      state.sectorLevel = "subcategories";
      state.currentSubCategoryId = null;
      state.currentSectorId = null;
    },
    clearTramite(state) {
      state.tramiteStore = null;
      state.categoryStore = null;
      state.subcategoryState = null;
    },
    setBodyInfractionState(state, obj) {
      state.changeStateStore = obj;
    },
    setModalUnreadSeen(state, bool) {
      state.modalUnreadSeen = bool;
    },
    setCategoriesRelations(state, dato) {
      state.categoriesRelations = dato;
    },
    SET_SIDEBAR_STATE(state, isOpen) {
      state.isSidebarOpen = isOpen;
    },
    TOGGLE_SIDEBAR(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    SET_FILTERS(state, { seccion, condiciones }) {
      state.filters[seccion] = { ...condiciones };
    },
    SET_LOADING(state, value) {
      state.loadingGlobal = value;
    },
    CLEAR_FILTERS(state) {
      state.filters = {
        tramites: {},
        turnos: {},
        tareas: {},
        vecinos: {},
      };
    },
  },
  actions: {
    mockLoginAction(context, asd) {
      context.commit("loggedIn", asd);
    },

    mockLoginRepresentativeAction(context, asd) {
      context.commit("loggedInRepresentative", asd);
    },
    mockOutAction(context) {
      context.commit("outLogin");
    },
    mockCidiAction(context, asd) {
      context.commit("setCidi", asd);
    },
    mockPaseAction(context) {
      context.commit("login");
    },
    setWidthAction(context, asd) {
      context.commit("setWidth", asd);
    },
    getCategoriasAction(context, asd) {
      context.commit("getCategorias", asd);
    },
    setTramiteAction(context, asd) {
      context.commit("setTramite", asd);
    },
    setSubCategoryAction(context, asd) {
      context.commit("setSubCategory", asd);
    },
    setCategoryAction(context, asd) {
      context.commit("setCategory", asd);
    },
    clearTramiteAction(context) {
      context.commit("clearTramite");
    },
    //para guardar la informacion de un cambio de estado en caso de pago y redireccion o cualquier corte
    saveBodyInfractionState(context, obj) {
      context.commit("setBodyInfractionState", obj);
    },
    //para limpiar los datos de un cambio de estado y sus imagenes
    clearBodyInfractionState(context) {
      context.commit("setBodyInfractionState", null);
    },
    //indicar si el modal de notis no leidas ya fue mostrado
    setModalUnreadSeenAction(context, bool) {
      context.commit("setModalUnreadSeen", bool);
    },
    setCategoriesRelationsAction(context, dato) {
      context.commit("setCategoriesRelations", dato);
    },
    setSidebarState(context, isOpen) {
      context.commit("SET_SIDEBAR_STATE", isOpen);
    },
    toggleSidebar(context) {
      context.commit("TOGGLE_SIDEBAR");
    },
    setFiltersAction({ commit }, payload) {
      commit("SET_FILTERS", payload);
    },
    clearFiltersAction({ commit }, seccion) {
      commit("CLEAR_FILTERS", seccion);
    },
    setLoading({ commit }, value) {
      commit("SET_LOADING", value);
    },
    setSectorLevelAction({ commit }, level) {
      commit("setSectorLevel", level);
    },
    setCurrentSubCategoryAction({ commit }, id) {
      commit("setCurrentSubCategory", id);
    },
    clearSectorNavigationAction({ commit }) {
      commit("clearSectorNavigation");
    },
  },
  modules: { notification },
  plugins: [vuexLocal.plugin],
});
